<template>
  <div
    :class="[
      `notification`,
      type === `success` && `notification--success`,
      type === `error` && `notification--error`,
      type === `warning` && `notification--warning`,
      type === `info` && `notification--info`,
    ]"
  >
    <span @click="handleIconClick">
      <icon
        v-if="icon"
        class-name="notification__icon"
        :name="icon"
        @click="handleIconClick"
      />
    </span>
    <div v-if="title" class="notification__title">{{ title }}</div>
    <div class="notification__text"><slot></slot></div>
    <div v-if="actions" class="notification__actions">
      <slot name="action-content">
        <a class="notification__actions__action">Default Modal Content from Slots (Fallback)</a>
      </slot>
    </div>
  </div>
</template>

<script>
// Components
import Icon from "../Icon/Icon.vue";

export default {
  name: "Notification",
  components: {
    Icon,
  },
  props: {
    /**
     * @description
     * Based on the type the notification classes are attached,
     * Maesk Design only supports success, error & warning info types.
     * Changes will be controlled by the Parent Component.
     */
    type: {
      type: String,
      validator: (val) => ["success", "error", "warning", "info"].includes(val),
      default: "success",
    },
    /**
     * @description
     * Title of the Notification.
     * Changes will be controlled by the Parent Component.
     */
    title: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Title of the Notification.
     * Changes will be controlled by the Parent Component.
     */
    icon: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Prop to toggle the visibility of the Notification.
     * Parent Component will control the behavior.
     */
    open: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Prop to toggle the visibility of the Notification Actions
     * Should be used with the slots (slot name - ction-content)
     */
    actions: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleIconClick() {
      this.$emit("handleIconClick");
    },
  },
};
</script>
